import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, BookOpenIcon, GiftIcon, WrenchIcon, BrainIcon, ZapIcon } from 'lucide-react';
const helps = ['entender dinámicas desgastantes', 'detectar manipulaciones emocionales', 'responder mejor', 'poner límites sin culpa', 'dejar de absorber tanto desgaste innecesario'];
const includes = [{
  icon: BookOpenIcon,
  text: '6 módulos completos'
}, {
  icon: GiftIcon,
  text: 'Bonus exclusivos'
}, {
  icon: WrenchIcon,
  text: 'Herramientas prácticas'
}, {
  icon: BrainIcon,
  text: 'Estrategias emocionales reales'
}, {
  icon: ZapIcon,
  text: 'Acceso inmediato'
}];
export function ProductPresentation() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-317" data-mp="1ydqqb69l90yz">
      <div className="max-w-4xl mx-auto" data-id="element-318" data-mp="2m4w29acer940">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-319" data-mp="2m31iw0gsbp21">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-320" data-mp="390eusyi9068f">
            <span className="text-xs font-bold tracking-widest" data-id="element-321" data-mp="348dm1mkagxn5">
              🏆 EL EBOOK
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-322" data-mp="3hz0a8ksfb54z">
            Una guía completa para recuperar tu{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-323" data-mp="3rxohqpms81uf">
              calma mental
            </span>
          </h2>
          <p className="font-serif-italic text-rose text-lg md:text-xl mt-4" data-id="element-324" data-mp="3my3cxykxkz9s">
            6 Módulos + 5 Bonus — Estrategias emocionales reales
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-7 md:p-10 mb-8 shadow-sm" data-id="element-325" data-mp="1snq4i3zj4ik7">
          <p className="text-ink-soft text-base md:text-lg mb-5" data-id="element-326" data-mp="ajtapcsxp2c9">
            Este ebook fue creado para ayudarte a:
          </p>
          <ul className="space-y-3 mb-2" data-id="element-327" data-mp="kgfxi74tm3gx">
            {helps.map((h, i) => <li key={i} className="flex items-center gap-3" data-id="element-328" data-mp="kecw6qy7wnww" data-mpi={i}>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-rose/10 flex items-center justify-center" data-id="element-329" data-mp="p8phl6j989ba">
                  <CheckIcon className="w-3.5 h-3.5 text-rose" strokeWidth={3} data-id="element-330" data-mp="t882w3ezmmen" />
                </span>
                <span className="text-ink" data-id="element-331" data-mp="136e5yocj5yl3">{h}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-332" data-mp="1dbx7nb8h6rxy">
          {includes.map((it, i) => <div key={i} className="flex items-center gap-3 bg-white border border-line rounded-2xl px-4 py-3.5 shadow-sm" data-id="element-333" data-mp="1w0u3hjjitsia" data-mpi={i}>
              <span className="flex-shrink-0 w-10 h-10 rounded-xl bg-rose/10 flex items-center justify-center" data-id="element-334" data-mp="1mb0rwijdpde1">
                <it.icon className="w-4 h-4 text-rose" data-id="element-335" data-mp="1i9fjpahshna6" />
              </span>
              <span className="font-semibold text-ink text-sm" data-id="element-336" data-mp="2esmtd53amxls">{it.text}</span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}